import React from "react";

import s from "./ui.module.scss";

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Apply default 16px padding. Default true. */
  padded?: boolean;
}

const Card = ({ padded = true, className, children, ...rest }: CardProps) => (
  <div
    className={[s.card, padded && s.cardPadded, className].filter(Boolean).join(" ")}
    {...rest}
  >
    {children}
  </div>
);

export default Card;
